import type { SVGProps } from "react";
const SvgTargets = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <path
      className="icon-color-4"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M23.5 25.5h-21v-5h6v-5h6v-5h9v15Z"
    />
    <path className="icon-color-4" fill="#fff" d="M18.5 10V1L24 3l-5.5 2.5" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M18.5 10V5.5m0 0V1L24 3l-5.5 2.5Z" />
  </svg>
);
export default SvgTargets;
